// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a0dd6cb2","732":"e56a0615","977":"180800ff"}[chunkId] + ".chunk.js";
};